import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "My little boy loved attending every day. It's so much easier when your child is desperately excited about attending a holiday club. The variety of the activities on offer ensured every child had something to look forward to. Aaron and Millie are very responsive and accommodating.",
  },
  {
    quote:
      "My guys absolutely loved it and have asked to go back again in the summer! Thank you. Plus the art work they brought back was amazing!",
  },
  {
    quote:
      "Loved everything, familiar faces with staff, sport, sport and more sport. Creativity for the younger ones also brilliant. So excited for more.",
  },
  {
    quote: "My boys had a brilliant time — thank you.",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="relative bg-white py-24 md:py-36 overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-sky-200/40 blur-3xl" />
      <div className="relative z-10 mx-auto max-w-7xl px-5">
        <div className="max-w-3xl">
          <span className="inline-block font-display font-bold text-sky-500 uppercase tracking-widest text-sm mb-4">
            Parent Feedback
          </span>
          <h2 className="font-display font-black tracking-tight text-slate-900 text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Don&apos;t take <span className="text-sky-500">our word</span> for
            it.
          </h2>
          <p className="mt-6 text-lg md:text-xl text-slate-600 font-medium">
            A few words from parents whose children have joined us at camp.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.55,
                delay: (i % 2) * 0.12,
                ease: [0.22, 1, 0.36, 1],
              }}
              data-testid={`testimonial-${i}`}
              className={`rounded-[2rem] border-2 p-8 md:p-10 shadow-[0_20px_50px_rgba(15,23,42,0.06)] ${
                i === 0
                  ? "bg-slate-900 border-slate-900 md:col-span-2"
                  : "bg-slate-50 border-slate-900/5"
              }`}
            >
              <Quote
                className={`h-8 w-8 ${
                  i === 0 ? "text-sky-400" : "text-sky-500"
                }`}
                fill="currentColor"
              />
              <blockquote
                className={`mt-5 font-display font-bold leading-snug ${
                  i === 0
                    ? "text-white text-2xl md:text-3xl"
                    : "text-slate-800 text-xl md:text-2xl"
                }`}
              >
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption
                className={`mt-5 text-sm font-bold uppercase tracking-widest ${
                  i === 0 ? "text-sky-400" : "text-sky-600"
                }`}
              >
                Parent
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
